/**
 * Mobile / portrait: strict `displaySurface: 'monitor'` and heavy ideals break
 * `getDisplayMedia` on many browsers. Shared by ScreenRecorder and useRecording.
 */
export function shouldRelaxDisplayCapture(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    if (window.matchMedia('(pointer: coarse)').matches) return true;
    if (window.matchMedia('(max-width: 600px) and (orientation: portrait)').matches) return true;
  } catch {
    /* ignore */
  }
  const w = Math.round(window.innerWidth || 0);
  const h = Math.round(window.innerHeight || 0);
  return w > 0 && w <= 600 && h > w;
}
